import { render, staticRenderFns } from "./QAgentSupportTicketsDataTable.vue?vue&type=template&id=51dba4f9&scoped=true&"
import script from "./QAgentSupportTicketsDataTable.vue?vue&type=script&lang=js&"
export * from "./QAgentSupportTicketsDataTable.vue?vue&type=script&lang=js&"
import style0 from "./QAgentSupportTicketsDataTable.vue?vue&type=style&index=0&id=51dba4f9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51dba4f9",
  null
  
)

export default component.exports